import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { FormattedMessage } from 'react-intl';
import { object, func } from 'prop-types';
import { startSetOffers, startSearchOffers } from '../../actions/offers';
import OffersFilter from './OffersFilter/OffersFilter';
import OffersSearch from './OffersSearch';

export class OffersListFilters extends Component {
  static propTypes = {
    filters: object.isRequired,
    onSearch: func.isRequired,
  };

  constructor(props) {
    super(props);

    const parsedParams = parse(window.location.search);

    this.state = {
      query: parsedParams.search ? parsedParams.search : '',
      // hardcoded filters for pixel groups
      // pixelGroups: [
      //   { id: '5', title: 'Подтвержденная заявка'},
      //   { id: '60', title: 'Подтверждение отмены'},
      //   { id: '1', title: 'Регистрация'},
      //   { id: '29', title: 'Первый депозит'},
      //   { id: '33', title: 'Квалификация'},
      //   { id: '30', title: 'Проигрыш игрока'},
      //   { id: '21,22,23,39,40,53,54', title: 'Кредит/Карта/Займ' },
      //   { id: '48,51,49,17,59', title: 'HR' },
      // ],
    };
  }

  handleChange = (e) => {
    const query = e.target.value;

    this.setState(
      () => ({ query }),
      () => {
        const { query } = this.state;
        this.props.onSearch(query);
      },
    );
  };

  isFilterNotEmpty = (name) =>
    this.props.filters[name] && this.props.filters[name].length ? true : false;

  render() {
    const { query } = this.state;
    const { filters } = this.props;

    if (!Object.keys(filters).length) return null;

    // Add hardcoded pixel groups
    // filters.pixelGroups = this.state.pixelGroups;

    return (
      <Fragment>
        <div className="offer-filters">
          <OffersSearch onChange={this.handleChange} query={query} />
          {/* <Fragment> */}
          {/* {this.isFilterNotEmpty('countries') ? (
              <FormattedMessage id="offers.filters.countries" defaultMessage="Countries">
                {(label) => (
                  <OffersFilter
                    name="countries"
                    defaultLabel={label}
                    items={filters.countries}
                    search
                  />
                )}
              </FormattedMessage>
            ) : null} */}
          {/* {this.isFilterNotEmpty('categories') ? (
              <FormattedMessage id="offers.filters.categories" defaultMessage="Categories">
                {(label) => (
                  <OffersFilter
                    name="categories"
                    defaultLabel={label}
                    items={filters.categories}
                    search
                  />
                )}
              </FormattedMessage>
            ) : null} */}
          {/*{this.isFilterNotEmpty('approved') ?*/}
          {/*  <FormattedMessage id="offers.filters.sources" defaultMessage="Sources">*/}
          {/*    {label => (*/}
          {/*      <OffersFilter*/}
          {/*        name="sources"*/}
          {/*        defaultLabel={label}*/}
          {/*        items={filters.approved}*/}
          {/*        search*/}
          {/*        className='offers_filters_sources'*/}
          {/*      />*/}
          {/*    )}*/}
          {/*  </FormattedMessage> : null*/}
          {/*}*/}
          {/* {this.isFilterNotEmpty('currencies') ? (
              <FormattedMessage id="offers.filters.currencies" defaultMessage="Currencies">
                {(label) => (
                  <OffersFilter name="currencies" defaultLabel={label} items={filters.currencies} />
                )}
              </FormattedMessage>
            ) : null} */}
          {/* {this.isFilterNotEmpty('pixelGroups') ? (
              <FormattedMessage id="offers.filters.targets" defaultMessage="Targets">
                {(label) => (
                  <OffersFilter
                    name="pixelGroups"
                    defaultLabel={label}
                    items={filters.pixelGroups}
                  />
                )}
              </FormattedMessage>
            ) : null} */}
          {/* </Fragment> */}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  filters: state.offers.filters,
});

const mapDispatchToProps = (dispatch) => ({
  startSearchOffers: (params) => dispatch(startSearchOffers(params)),
  startSetOffers: () => dispatch(startSetOffers()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OffersListFilters);
